import React, { useEffect, useRef } from "react";

function FluidBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return undefined;
    }

    if (window.navigator.userAgent.includes("jsdom")) {
      return undefined;
    }

    let context;
    try {
      context = canvas.getContext("2d");
    } catch (error) {
      return undefined;
    }

    if (!context) {
      return undefined;
    }

    let frame = 0;
    let animationId;

    const resize = () => {
      const ratio = window.devicePixelRatio || 1;
      canvas.width = window.innerWidth * ratio;
      canvas.height = window.innerHeight * ratio;
      canvas.style.width = `${window.innerWidth}px`;
      canvas.style.height = `${window.innerHeight}px`;
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
    };

    const draw = () => {
      frame += 0.005;
      const width = window.innerWidth;
      const height = window.innerHeight;
      context.clearRect(0, 0, width, height);
      context.globalCompositeOperation = "lighter";

      for (let i = 0; i < 5; i += 1) {
        const x = width * (0.15 + i * 0.2) + Math.sin(frame * (i + 1.3)) * 80;
        const y = height * (0.25 + (i % 3) * 0.24) + Math.cos(frame * (i + 2)) * 60;
        const gradient = context.createRadialGradient(x, y, 0, x, y, 260);
        gradient.addColorStop(0, i % 2 ? "rgba(18, 194, 164, 0.16)" : "rgba(94, 255, 176, 0.12)");
        gradient.addColorStop(0.5, "rgba(11, 77, 89, 0.045)");
        gradient.addColorStop(1, "rgba(0, 0, 0, 0)");
        context.fillStyle = gradient;
        context.beginPath();
        context.arc(x, y, 260, 0, Math.PI * 2);
        context.fill();
      }

      context.globalCompositeOperation = "source-over";
      animationId = window.requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener("resize", resize);

    return () => {
      window.cancelAnimationFrame(animationId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas className="fluid-background" ref={canvasRef} aria-hidden="true" />;
}

export default FluidBackground;
